import * as React from 'react';
import { Waypoint } from 'react-waypoint';
import { CodetableListItemsContainerProps } from './types';

export const CodetableListItemWaypoint = ({ parentId, onLoadMore }) =>
  <Waypoint key={`wpCode${parentId}`} onEnter={onLoadMore} scrollableAncestor={window} bottomOffset="-10%" />;

export class CodetableListItemsContainer extends React.PureComponent<CodetableListItemsContainerProps> {

  public componentDidMount() {
    this.loadCode(false);
  }

  public componentDidUpdate() {
    this.loadCode(false);
  }

  private onLoadMore = () => {
    this.loadCode(true);
  };

  private loadCode = (appendToList: boolean) => {
    const { parentId, codeBranch, codeBranchState, loadFromParent } = this.props;

    if (!codeBranchState || !codeBranchState.open || codeBranchState.fetching) {
      return;
    }

    if (appendToList || codeBranchState.needsReload || !codeBranch) {

      const clearList = !appendToList || codeBranchState.needsReload;
      const startIndex = !clearList && codeBranch && codeBranch.items
        ? codeBranch.items.length
        : 0;

      if (startIndex > 0 && codeBranch.items.length >= codeBranch.numberOfResults) {
        return;
      }

      loadFromParent(parentId, startIndex);
    }
  };

  public render() {

    const { parentId, codeBranch, children } = this.props;

    if (!codeBranch || !codeBranch.items || !codeBranch.items.length) {
      return null;
    }

    return <div>
      {children}
      <CodetableListItemWaypoint parentId={parentId} onLoadMore={this.onLoadMore} />
    </div>;
  }
}
